import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { useMemo } from 'react';
import { themeDeepMerge } from './utils/themeDeepMerge';
import { getLightTheme } from './themes/light';
import { getDarkTheme } from './themes/dark';
import { paletteTokens } from './generated/paletteVariables';
import { useBrandingOverrides } from './brandingContext';
const themeGetters = {
    light: getLightTheme,
    dark: getDarkTheme
};
export const ThemeProvider = ({ children, themeName })=>{
    const branding = useBrandingOverrides();
    const activeTheme = useMemo(()=>{
        const overridePalette = branding?.overridePalette;
        const overrideTheme = branding?.overrideTheme;
        const palette = overridePalette ? themeDeepMerge(paletteTokens, overridePalette) : undefined;
        const baseTheme = themeGetters[themeName](palette);
        if (!overrideTheme) {
            return baseTheme;
        }
        return themeDeepMerge(baseTheme, overrideTheme);
    }, [
        themeName,
        branding
    ]);
    return /*#__PURE__*/ _jsx(MuiThemeProvider, {
        theme: activeTheme,
        children: children
    });
};

//# sourceMappingURL=themeProvider.js.map